$(function () {
    const submitForm = ($form) => {
        var submitUrl = $form.getAttribute('action');
        var successMessage = $form.dataset.successMessage;
        var isCombinedForm = $form.querySelector('input[name="apsisfirstname"]') != null; //check if more then email textbox

        var data = {
            email: $form.querySelector('input[name="apsisemail"]').value,
            tag: $form.dataset.tag,
            topic: $form.dataset.topic,
            firstname: isCombinedForm
                ? $form.querySelector('input[name="apsisfirstname"]').value
                : '',
            lastname: isCombinedForm
                ? $form.querySelector('input[name="apsislastname"]').value
                : '',
            company: isCombinedForm ? $form.querySelector('input[name="apsiscompany"]').value : '',
            department: isCombinedForm
                ? $form.querySelector('input[name="apsisdepartment"]').value
                : '',
            address: isCombinedForm ? $form.querySelector('input[name="apsisaddress"]').value : '',
            coaddress: isCombinedForm ? $form.querySelector('input[name="apsisco"]').value : '',
            postal: isCombinedForm ? $form.querySelector('input[name="apsispostal"]').value : '',
            city: isCombinedForm ? $form.querySelector('input[name="apsiscity"]').value : '',
            role:
                $form.querySelector('select[name="apsisrole"]') != null
                    ? $form.querySelector('select[name="apsisrole"]').value
                    : '',
            type: isCombinedForm ? $form.querySelector('input[name="apsistype"]').value : ''
        };
        $form.querySelectorAll('div.alert').forEach((el) => {
            el.remove();
        });

        fetch(submitUrl, {
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
        })
            .then((response) => response.json())
            .then((result) => {
                if (result == 'Ok') {
                    // Add push to dataLayer
                    if (window.dataLayer && $form.closest('#ms-form--container') != null) {
                        window.dataLayer.push({
                            event: 'new_subscriber_arbetsliv',
                            apsisType: $form.querySelector('input[name="apsistype"]').value
                        });
                    }

                    $form.insertAdjacentHTML(
                        'afterBegin',
                        `<div role="alert" class="alert alert-primary">${successMessage}</div>`
                    );
                    $form.classList.remove('was-validated');
                    $form.reset();
                } else {
                    $form.insertAdjacentHTML(
                        'afterBegin',
                        '<div role="alert" class="alert alert-danger">Något gick fel. Kontakta kundservice.</div>'
                    );
                }
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    };

    var apsisForms = document.querySelectorAll('.apsis-form');
    if (apsisForms != null && apsisForms.length > 0) {
        for (var i = 0; i < apsisForms.length; i++) {
            apsisForms[i].addEventListener('submit', (e) => {
                e.preventDefault();
                var formElement = e.target;

                const ohnohoney = formElement.querySelector('input.ohnohoney');
                if (ohnohoney.value != '') {
                    formElement.insertAdjacentHTML(
                        'afterBegin',
                        '<p class="text-danger">You are trapped</p>'
                    );
                    return;
                }

                var apsisType = formElement.querySelector('input[name="apsistype"]');
                if (apsisType != null && apsisType.value == 0) {
                    if (e.currentTarget.checkValidity()) {
                        submitForm(formElement);
                    }
                } else {
                    var apsisEmail = formElement.querySelector('input[name="policyCheck"]');
                    var policyCheck = formElement.querySelector('input[name="apsisemail"]');

                    if (apsisEmail.checkValidity() && policyCheck.checkValidity()) {
                        submitForm(formElement);
                    }
                }
            });
        }
    }
});
